import '../javascripts/jqueryLoader';

import Rails from '@rails/ujs';
import 'bootstrap';
import 'jquery-sparkline';
import '../javascripts/froogaloop';
import '../javascripts/jquery.fitvid';
import '../javascripts/jquery.flexslider';
import '../javascripts/jquery.slimscroll';
import '../javascripts/custom';
import '../javascripts/ConsultantRanker';
import '../javascripts/TerritoryChecksBrandSelect';
import '../javascripts/SalesManualInputBrandSelect';
import '../javascripts/SalesManualInputSelect';
import '../javascripts/super_admin/SentEmailsTable';
import '../javascripts/super_admin/LeadOwnersTable';
import '../javascripts/super_admin/BrokersTable';
import '../javascripts/super_admin/UsersTable';
import '../javascripts/super_admin/DivisionsTable';
import '../javascripts/super_admin/LeadsTable';
import '../javascripts/super_admin/EngagementsTable';
import '../javascripts/super_admin/PipelineStagesTable';
import '../javascripts/DirectorRanker';
import '../javascripts/RegisteredConsultants';
import '../javascripts/UnregisteredConsultants';
import '../javascripts/tinymce';

import init from '../javascripts/app';
Rails.start();
init()
